/* The three content pillars, parsed out of her locked visibility work.
 *
 * LIFTED OUT OF SocialGenerator.jsx 2026-09-17, unchanged, because the
 * Newsletter module needs the same three: every blog post reinforces one of her
 * pillars (her requirement), and the pillar list is HER WORDS from the
 * Accelerator — never a hardcoded set. Two parsers over the same prose would
 * eventually disagree about which pillars she has, and one of them would be the
 * one on screen.
 *
 * This is the Accelerator-to-Momentum read CLAUDE.md warns about: it fails
 * silently (no pillars simply means no pillar picker), so `pillars.test.js`
 * pins the shape it parses.
 */


// Parses the locked "Content Pillars" output. The My Visibility prompt emits a
// fixed structure we can read deterministically:
//
//   PILLAR 1: <name>
//   <content-type label — one-line role>
//   <description>
//   Themes:
//   - <theme>  (4-6)
//   Content angles for <channel>:
//   1. "<angle>"  (5)
//
// We key strictly on "PILLAR N:" so only the three real pillars are picked up
// (never descriptions or angle lines). Themes come from the "Themes:" list.
// Older locked outputs without a "Themes:" section parse fine but with no themes
// (the UI prompts a quick re-lock). A no-header fallback keeps nothing from crashing.

export function parsePillars(text) {
  if (!text || !text.trim()) return [];
  const lines = text.split("\n");
  const headerRe = /^\s*PILLAR\s+\d+\s*:/i;
  const idxs = [];
  lines.forEach((l, i) => { if (headerRe.test(l)) idxs.push(i); });

  if (idxs.length === 0) {
    return [{ label: "My content pillars", subtitle: "", description: text.trim().slice(0, 400), themes: [] }];
  }

  const pillars = [];
  for (let p = 0; p < idxs.length && pillars.length < 3; p++) {
    const start = idxs[p];
    const end = p + 1 < idxs.length ? idxs[p + 1] : lines.length;
    const block = lines.slice(start, end);
    const name = block[0].replace(/^\s*PILLAR\s+\d+\s*:\s*/i, "").trim();

    let i = 1;
    while (i < block.length && !block[i].trim()) i++;
    let subtitle = "";
    if (i < block.length && !/^themes\s*:?/i.test(block[i].trim()) && !/^[-•*]\s/.test(block[i].trim())) {
      subtitle = block[i].trim(); i++;
    }

    const descLines = [];
    for (; i < block.length; i++) {
      const t = block[i].trim();
      if (/^themes\s*:?/i.test(t) || /content angles/i.test(t)) break;
      if (t) descLines.push(t);
    }

    const themes = [];
    let inThemes = false;
    for (let j = 1; j < block.length; j++) {
      const t = block[j].trim();
      if (/^themes\s*:?/i.test(t)) { inThemes = true; continue; }
      if (inThemes) {
        if (!t) continue;
        const m = t.match(/^[-•*]\s+(.+)/);
        if (m) { themes.push(m[1].trim()); continue; }
        break;
      }
    }

    pillars.push({ label: name, subtitle, description: descLines.join(" "), themes: themes.slice(0, 6) });
  }
  return pillars;
}

/** Just the names, for a picker. */
export const pillarLabels = (text) => parsePillars(text).map((p) => p.label).filter(Boolean);
